<div class="d-flex align-items-center">
    <div class="flex-grow-0 mr-3 icon-container">
        <div class="icon-circle border rounded-circle text-muted bg-white">
            <fa-icon
                [fixedWidth]="true"
                [icon]="['far', 'paperclip']"
                size="lg"
            ></fa-icon>
        </div>
    </div>
    <div class="flex-grow-1" style="margin-top: 0.4em">
        <p class="m-0">
            <b [pTooltip]="shipmentActivity.user?.email">
                {{ shipmentActivity.user?.name || '@system' }}
            </b>
            {{'portal.shipment.page.activities.attached' | translate}}
            <a [queryParams]="{ view: 'attachments' }" [routerLink]="[]">
                {{ shipmentActivity.data.filename }}
            </a>
            <span class="text-muted">
                {{ shipmentActivity.created_at | amTimeAgo }}
            </span>
        </p>
    </div>
</div>
